import {
	PUBLIC_PAGE_API_ENDPOINT,
	PUBLIC_MYPAGES_API_ENDPOINT,
} from "../../../constants"

export const deleteAccount = () => {
	const url =
		PUBLIC_PAGE_API_ENDPOINT + PUBLIC_MYPAGES_API_ENDPOINT + `/account`

	return fetch(url, {
		method: "DELETE",
	}).then((res) => {
		return res.json().then((json) => ({
			success: res.status === 200,
			data: json,
			statusCode: res.status,
		}))
	})
}

export const onRemoveAccountClick = async () => {
	const result = await deleteAccount()

	if (result.success) {
		// Redirect to result.data.redirectUrl
		if (result.data?.redirectUrl) {
			window.location.href = result.data?.redirectUrl
		} else {
			console.error("No redirect URL in response", result)
		}
	} else {
		console.error(
			`Request to remove account failed with status code ${result.statusCode}`
		)
	}
}
